module.exports = __webpack_public_path__ + "img/tinsoldier-img.732563f3.jpg";